export const ignoredAnnotations = [
  'in the frameset phase. Ignored.',
  'Expected e.g. <!DOCTYPE html>.',
  'Unexpected end tag (noscript). Ignored.',
  'Named entity expected. Got none.',
]
